<template>
  <v-container>
    <v-card style="margin-bottom:1em">
      <v-card-title> Automatic process #{{ $route.params.id }}<span v-if="state !== null && state.process_klass !== null">: <ProcessKlass :klass="state.process_klass"/></span> </v-card-title>
      <v-card-text v-if="lastUpdated !== null">
        <label>Last updated:</label>&#32;{{ lastUpdated }}<br>
      </v-card-text>
    </v-card>
    <template v-if="state === null">
      <v-card style="margin-bottom:1em">
        <v-card-text>
          Loading...
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <v-card style="margin-bottom:1em">
        <v-card-text v-if="state === null">
          Loading...
        </v-card-text>
        <v-card-text v-else>
          <b><u>Summary</u></b><br>
          <label>Status:</label>&#32;<ProcessExecutionStatus :rc="state.rc" :signum="state.signum" /><br>
          <template v-if="state !== null && state.process_klass !== null">
            <label>Process type:</label>&#32;
            <ProcessKlass :klass="state.process_klass"/>
            <br>
          </template>
          <label>Command:</label>&#32;
            <span style="font-family:monospace">{{ state.bin_path }}</span>
            <span v-for="arg in formatedArguments" style="font-family:monospace">&#32;{{ arg }}</span><br>
          <label>Host:</label>&#32;<span style="font-family:monospace">{{ state.hostname }} ({{ state.host_os }})</span><br>
          <template v-if="startedDate">
            <label>Started at:</label>&#32; <span :title="state.started_date">{{ startedDate }}</span><br>
          </template>
          <template v-if="endedDate">
            <label>Finished at:</label>&#32; <span :title="state.ended_date">{{ endedDate }}</span><br>
          </template>
        </v-card-text>
      </v-card>
    </template>
    <v-alert v-for="item in items" :type="item._type" style="margin-bottom:1em">
      <template v-if="item.title">
        <strong>{{ item.title}}</strong> |
      </template>
      <template v-if="item.point">
        <span style="font-family:monospace">@{{ item.point }}</span> |
      </template>
      <em :title="item.createdate">{{ item._ts }}</em><br>
      {{ item.payload }}
    </v-alert>
  </v-container>
</template>

<script>

import moment from 'moment-timezone';
import ProcessExecutionStatus from '../../components/reports/process-execution-status.vue';
import ProcessKlass from '../../components/reports/process-klass';

const TIME_FORMAT = 'D MMM YYYY h:mm:ss a z';

export default {
  name: "AutomaticProcessPage",
  components: {
    ProcessExecutionStatus,
    ProcessKlass
  },
  data() {
    return {
      count: 0,
      loading: true,
      items: [],
      state: null,
      lastUpdated: null,
      refreshTimer: null
    };
  },
  async created() {
    if(!(/^[0-9]{1,10}$/.test(this.$route.params.id))) {
      this.$router.push('/admin/automatic-processes');
      return;
    }
    this.refreshState();
  },
  beforeDestroy: function() {
    if(this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
  computed: {
    formatedArguments: function() {
      if(!this.state) {
        return [];
      }
      var vector;
      try {
        vector = JSON.parse(this.state.argv);
      }
      catch(e) {
        return [];
      }
      if(!(vector instanceof Array)) {
        return [];
      }
      return vector.map(x => {
        if(/^[a-zA-Z0-9_-]*$/.test(x)) {
          return x;
        }
        else {
          return "'" + x.replace("\'", "\\\'").replace('\\', '\\\\') + "'";
        }
      });
    },
    startedDate: function() {
      if(this.state.started_date === null) {
        return null;
      }
      else {
        return moment.utc(this.state.started_date).tz('Pacific/Auckland').format(TIME_FORMAT);
      }
    },
    endedDate: function() {
      if(this.state.ended_date === null) {
        return null;
      }
      else {
        return moment.utc(this.state.ended_date).tz('Pacific/Auckland').format(TIME_FORMAT);
      }
    }
  },
  watch: {
    tableOptions: {
      handler: function() {
        const {page, itemsPerPage } = this.tableOptions;
        this.loadItems((page - 1) * itemsPerPage, itemsPerPage);
      },
      deep: true
    }
  },
  methods: {
    setRefreshTimer: function() {
      this.refreshTimer = setTimeout(() => {
        this.refreshTimer = null;
        this.refreshState();
      }, 10000);
    },
    refreshState: async function() {
      const response = await this.$http.get(`/processexecutions/${this.$route.params.id}`);
      const largest_id = this.items.length == 0 ? -1 : this.items[0].id;
      const filter = {
        where: {
          processexecution_id: this.$route.params.id,
          id: {'gt': largest_id},
          klass: {'nin': ['stdout', 'stderr', 'stats', 'debug']}
        },
        limit: 75,
        order: ['id ASC']
      };
      const response2 = await this.$http.get('/processexecutionlogentries?filter=' + encodeURIComponent(JSON.stringify(filter)));
      if(response2.status == 200) {
        for(const entry of response2.data) {
          entry._ts = moment.utc(entry.createdate).tz('Pacific/Auckland').format(TIME_FORMAT);
          if(entry.klass == 'success') {
            entry._type = 'success';
          }
          else if(entry.klass == 'failure') {
            entry._type = 'error';
          }
          else if(entry.klass == 'warning') {
            entry._type = 'warning';
          }
          else if(entry.klass == 'info') {
            entry._type = 'info';
          }
          else if(entry.klass == 'progress') {
            entry._type = 'info';
          }
          else if(entry.klass == 'action-required') {
            entry._type = 'warning';
          }
          this.items.unshift(entry);
        }
      }
      if(response.status == 200) {
        this.state = response.data;
        this.lastUpdated = moment.utc().tz('Pacific/Auckland').format(TIME_FORMAT);
        
      }
      if((this.state.rc === null && this.state.signum === null) || response2.status != 200 || response2.data.length == 75) {
          this.setRefreshTimer();
      }
    }
  },
};
</script>
